export const blogFAQData = [
  {
    question: "Wie oft erscheinen neue Blog-Artikel zu Finanzcoaching und Führung?",
    answer: "Neue Artikel zu Finanzcoaching, Executive Coaching und persönlicher Entwicklung erscheinen regelmäßig. Sie enthalten praxisnahe Tipps, wissenschaftlich fundierte Erkenntnisse und Erfahrungen aus meiner Coaching-Arbeit mit Führungskräften und Privatpersonen."
  },
  {
    question: "Welche Themen behandeln die Blog-Artikel?",
    answer: "Meine Artikel behandeln Finanzcoaching, emotionale Intelligenz, Führungskräfte-Entwicklung, Outdoor-Coaching, Neuroplastizität und moderne Themen wie KI im Coaching. Alle Inhalte sind praxisorientiert und direkt anwendbar."
  },
  {
    question: "Kann ich Artikel-Themen zu Finanzcoaching vorschlagen?",
    answer: "Ja, gerne! Schicken Sie mir Ihre Fragen zu Finanzcoaching, Executive Coaching oder Führungsthemen. Interessante Fragestellungen greife ich in zukünftigen Artikeln auf und beantworte sie ausführlich."
  },
  {
    question: "Sind die Blog-Inhalte wissenschaftlich fundiert?",
    answer: "Absolut. Alle Artikel basieren auf bewährten Coaching-Methoden, aktueller Finanzforschung, Neurowissenschaften und meiner praktischen Erfahrung als Finanz- und Executive Coach. Quellen und Studien werden transparent angegeben."
  },
  {
    question: "Kann ich Blog-Artikel für mein Unternehmen oder Team nutzen?",
    answer: "Die Artikel sind für den privaten und beruflichen Gebrauch konzipiert. Führungskräfte können sie gerne für ihr Team verwenden. Bei umfangreicher gewerblicher Nutzung kontaktieren Sie mich für eine Abstimmung."
  },
  {
    question: "Bieten Sie auch individuelles Finanz- und Executive Coaching zu den Blog-Themen?",
    answer: "Ja, ich biete sowohl Finanzcoaching für Privatpersonen als auch Executive Coaching für Führungskräfte an. Meine Blog-Artikel zu Finanz- und Executive Coaching geben einen ersten Einblick, im persönlichen Coaching gehen wir individuell auf Ihre spezifischen Herausforderungen ein."
  },
  {
    question: "Wo finde ich Artikel zum Outdoor-Coaching?",
    answer: "Artikel zum Outdoor-Coaching und Walk & Talk Coaching finden Sie in der Kategorie 'Coaching-Methoden'. Diese einzigartige Coaching-Form praktiziere ich am Rothsee in Bayern."
  }
];